import { StringIterator } from 'lodash';
import { Funder } from '../funder';

export class MissionType {
	readonly id: number;
	type: string;
	colorCode: number;
	forExternalService: boolean;
	employeeExternal: boolean;
	autoAssignment: boolean;
	editable: boolean;
	numberOfEmployee: number;
	funder: Funder;
}
